import { Resources, useResource } from "Translations/Resources";
import { Typography, Stack } from "@mui/material";
import type { NotificationDto } from "Infrastructure/Api/Api";
import { ManagementNotification } from "Components/Notifications/NotificationsManagement/ManagementNotification";

const RESOURCES = Resources.Pages.Content.NotificationsManagement;

type Props = {
  title: string;
  notifications: NotificationDto[];
  onDelete?: (id: string) => void;
  onRestore?: (id: string) => void;
  onEdit?: (id: string) => void;
  isDimmed?: boolean;
};

export const NotificationsGroup = ({
  title,
  notifications,
  onDelete,
  onRestore,
  onEdit,
  isDimmed = false,
}: Props) => {
  const { t } = useResource();
  const isEmpty = notifications.length === 0;

  return (
    <Stack gap={2}>
      <Typography variant="h6">{title}</Typography>
      {isEmpty ? (
        <Typography color="text.secondary">
          {t(RESOURCES.NoNotifications)}
        </Typography>
      ) : (
        <Stack gap={2}>
          {notifications.map((notification: NotificationDto) => (
            <ManagementNotification
              isDimmed={isDimmed}
              key={notification.publicID}
              notification={notification}
              onDelete={onDelete}
              onRestore={onRestore}
              onEdit={onEdit}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};
